    <template>
    <div class="body-panel dataContent">
        <div class="body-panel-control separator">
            <div class="body-panel-control-separator">
                <div class="control-block-left">
                    <div class="flex">
                        <p class="btn-back caption-help margin-right-10">
                            <router-link :to="$route.query.returnUrl ? $route.query.returnUrl : '/projects/' + $route.params.projectId">Проект</router-link>
                        </p>
                        <p class="caption-help margin-right-10">
                            Торговые точки
                        </p>
                    </div>
                </div>
                <div class="control-block-right">
                    <div class="btns flex">
                        <input type="file" id="dropFiles" ref="dropFiles" name="dropFiles"
                               class="file-upload-zone-btn" accept=".xlsx" @change="onFileChange()" />
                        <button type="button" class="btn" onclick="document.getElementById('dropFiles').click()">
                            Импорт
                        </button>
                        <button class="btn" @click="onExport()">
                            Экспорт
                        </button>
                        <button id="sample_editable_1_2_new" class="btn" @click.stop="onAddItem()">
                            Добавить
                        </button>
                    </div>
                </div>
            </div>
            <div class="body-panel-control-separator">

                <complex-filter :filters="tradePointsFilters"
                                :searchFunction="searchFunction"
                                :tableName="'[dbo].[TradePoint]'"
                                @onFilterChange="onFilterChange">
                </complex-filter>
            </div>

        </div>
        <div class="body-panel-content body-panel-content-page">
            <div v-if="importResult != null">
                Успешно импортировано: {{ importResult.SuccessfullyExported }} строк<br><br>
                <template v-if="importResult.Errors.length">
                    Ошибки:<br>
                    <ul>
                        <li v-for="error of importResult.Errors">
                            {{error}}
                        </li>
                    </ul>
                </template>
                <button class="btn" @click="importResult = null;">Закрыть</button>
            </div>

            <table class="table-view" id="dataTable">
                <thead>
                    <tr class="heading">
                        <th>Наименование</th>
                        <th>Внешний ID</th>
                        <th>Регион</th>
                        <th>Область</th>
                        <th>Город</th>
                        <th>Адрес</th>
                        <th>Дата</th>
                        <th>Включена?</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) of tradePoints" @click.stop="onItemClick(item, i)" v-bind:class="{ 'table-point-row-off': !item.Enabled }">
<!--                        <template>-->
                            <td class="table-point-name">{{item.Name}}<p class="input-text-lbl">{{item.ExternalId}}</p></td>
                            <td class="table-point-address">{{item.Region}}, {{item.City}}, {{item.Address}}, {{item.Shop}}</td>
                            <td class="table-point-daterange">{{ formatDate(item.CreateDate) }} - {{ formatDate(item.EndDate) }}</td>
                            <td class="table-point-users">
<!--                                <div class="flex" v-for="role of getGroupedRoles(item.Roles)">-->
<!--                                    <p class="table-point-users-role">{{ role.RoleName }}:</p>-->
<!--                                    <p class="table-point-users-user">{{ role.Users.join('; ') }}</p>-->
<!--                                </div>-->
                                <div v-for="role of getGroupedRoles(item.Roles)">
                                    <span>{{ role.RoleName }}:</span>
                                    <span>{{ role.Users.filter(x => !x.Disabled).join('; ') }}</span>
                                </div>
                            </td>
                            <td class="obtn"></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <popup-window ref="ppTradepointEdit" :title="'Редактирование торговой точки'" :width="'1200px'" v-if="selectedTradepoint != null" :modal="false">

            <div class="form-field-group">
                <div class="table-point-name">
                    <div class="form-field">
                        <label class="input-text-lbl">Название</label>
                        <input placeholder="Название" type="text" name="Name" v-model="selectedTradepoint.Name" v-validate="'required'" :class="['input-text', {'input-error': errors.has('Name')}]" />
                    </div>
                    <div class="form-field margin-top-5">
                        <label class="input-text-lbl">Внешний ID</label>
                        <input placeholder="Внешний ID" type="text" name="ExternalId" v-model="selectedTradepoint.ExternalId" class="input-text" />
                    </div>
                    <div class="form-field margin-top-5" v-if="linkingEnabled">
                        <label class="input-text-lbl">Поле для связи</label>
                        <input placeholder="" type="text" name="SkuLink" v-model="selectedTradepoint.SkuLink" :class="['input-text', {'input-error': errors.has('SkuLink')}]" />
                    </div>
                    <div class="form-field margin-top-5">
                        <label class="input-text-lbl">Широта</label>
                        <input placeholder="Широта"
                               type="text"
                               name="Latitude"
                               :class="['input-text', {'input-error': errors.has('Latitude')}]"
                               v-model="selectedTradepoint.Latitude"
                               v-validate="{lonlat: true}"
                               data-vv-as="Широта" />
                        <span class="field-validation-valid">{{ errors.first('Latitude') }}</span>
                    </div>
                    <div class="form-field margin-top-5">
                        <label class="input-text-lbl">Долгота</label>
                        <input placeholder="Долгота" 
                               type="text" 
                               name="Longitude" 
                               :class="['input-text', {'input-error': errors.has('Longitude')}]"
                               v-model="selectedTradepoint.Longitude" 
                               v-validate="{lonlat: true}" 
                               data-vv-as="Долгота" />
                        <span class="field-validation-valid">{{ errors.first('Longitude') }}</span>
                    </div>
                    <div class="form-field margin-top-5">
                        <input id="Enabled" type="checkbox" class="input-checkbox" v-model="selectedTradepoint.Enabled" />
                        <label for="Enabled" class="input-checkbox-lbl">Активна</label>
                    </div>
                </div>
                <div class="table-point-address">
                    <div class="form-field">
                        <label class="input-text-lbl">Регион</label>
                        <input placeholder="Регион" type="text" name="Region" v-model="selectedTradepoint.Region" :class="['input-text', {'input-error': errors.has('Region')}]" />
                    </div>
                    <div class="form-field margin-top-5">
                        <label class="input-text-lbl">Область</label>
                        <input placeholder="Область" type="text" name="Area" v-model="selectedTradepoint.Area" :class="['input-text', {'input-error': errors.has('Area')}]" />
                    </div>
                    <div class="form-field margin-top-5">
                        <label class="input-text-lbl">Город</label>
                        <input placeholder="Город" type="text" name="City" v-model="selectedTradepoint.City" v-validate="'required'" :class="['input-text', {'input-error': errors.has('City')}]" />
                    </div>
                    <div class="form-field margin-top-5">
                        <label class="input-text-lbl">Адрес</label>
                        <input placeholder="Адрес" type="text" name="Address" v-model="selectedTradepoint.Address" v-validate="'required'" :class="['input-text', {'input-error': errors.has('Address')}]" />
                    </div>
                    <div class="form-field margin-top-5">
                        <label class="input-text-lbl">Магазин</label>
                        <input placeholder="Магазин" type="text" name="Shop" v-model="selectedTradepoint.Shop" class="input-text" />
                    </div>
                </div>
                <div class="form-field">

                    <div class="form-field" v-for="(roles, rolesIndex) of tradepointRolesGrouped">
                        <div class="flex margin-bottom-10">
                            <div class="" style="width:50%;">
                                {{roles[0].RoleName}}:
                            </div>
                            <div class="form-field">
                                <div class="form-field-group margin-bottom-5" v-for="(role, index) of roles">
                                    <div class="form-field">
                                        <search-filter :key="'TradeSearch' + role.ControlUniqueId"
                                                       :searchOnSelect="true"
                                                       :placeholder="'Выберите пользователя'"
                                                       :extra="role.RoleId"
                                                       :searchFunction="searchUserFunction"
                                                       :selectedItem="getFilterValue(role)"
                                                       :disabled="role.Disabled"
                                                       @onFilterChange="tradePointUserChange($event, role)">
                                        </search-filter>
                                    </div>
                                    <div class="">
                                        <button type="button" class="btn btn-default btn-img" @click="onRemoveUser(roles, index, rolesIndex)" v-if="roles.length > 1">
                                            <img src="../../img/icon-del.png" alt="" />
                                        </button>
                                    </div>
                                    <div class="">
                                      <button type="button" class="btn btn-default btn-img" @click="onDisableUser(roles, index, rolesIndex)" :title="(role.Disabled ? 'Включить' : 'Отключить')">
                                          <i :class="['fa', {'fa-chain': role.Disabled}, {'fa-chain-broken': !role.Disabled}]" />
                                      </button>
                                    </div>
                                    <div class="" v-if="index === roles.length-1">
                                        <button type="button" class="btn btn-default btn-img" @click="onAddUser(roles, role)">
                                            <i class="fa fa-plus" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btns flex margin-top-20" data-toggle="buttons">
                <button type="button" class="btn btn-primary" @click="saveItem(selectedTradepoint)">Сохранить</button>
                <button type="button" class="btn" @click="onCancel(selectedTradepoint)">Отмена</button>
            </div>
        </popup-window>

        <vue-headful title="Торговые точки" />
    </div>
</template>

<script>
    import $ from 'jquery'
    import UI from '../helpers/ui-helpers'
    import BackendApi from '../backendApi'
    import moment from 'moment'
    import _ from 'lodash'
    import config from '../config'
    import projectMixin from '../helpers/project-mixin'
    import Vue from "vue";

    let backendApi = new BackendApi();

    let rowsPerPage = 50;
    export default {
        name: "trade-points",

        mixins: [projectMixin],

        data() {
            return {
                tradePoints: [],
                loading: false,
                canBeLoaded: true,
                page: 1,
                tradePointsFilters: [
                    {
                        Value: 'Name', Name: 'Название'
                    },
                    {
                        Value: 'Region', Name: 'Регион'
                    },
                    {
                        Value: 'Area', Name: 'Область'
                    },
                    {
                        Value: 'City', Name: 'Город'
                    },
                    {
                        Value: 'Address', Name: 'Адрес'
                    }
                ],
                filter: null,
                roles: [],
                users: [],
                importResult: null,
                bonusSettings: null,
                ReportSettings: null,

                selectedTradepoint: null,
                selectedTradepointIndex: null,
                tradepointRolesGrouped: [],
                originData: null
            }
        },

        computed:{
            linkingEnabled(){
                if(this.ReportSettings) {
                    return this.ReportSettings.filter(x => {
                        return x.type === 'sku' && !x.deleted;
                    }).length > 0;
                }
                else{
                    return false;
                }
            }
        },

        methods: {
            getGroupedRoles(roles){
                let groupedRoles = [];
                _.each(_.groupBy(roles, 'RoleId'), (v) => {
                        groupedRoles.push({
                            RoleName: v[0].RoleName,
                            Users: _.map(_.filter(v, (x) => x.UserFio && !x.Disabled), (x) => x.UserFio)
                        });
                });
                return groupedRoles;
            },

            tradepointEditShow(tt, index){
                let vm = this;

                vm.selectedTradepoint = tt;
                vm.selectedTradepointIndex = index;
                vm.originData = JSON.parse(JSON.stringify(tt));

                vm.tradepointRolesGrouped = [];
                _.each(_.groupBy(vm.selectedTradepoint.Roles, 'RoleId'), (v) => {
                    // не показываем при редактировании роли с полным доступом к тт
                    if(!v[0].TtAccess) {
                        vm.tradepointRolesGrouped.push(v);
                    }
                });

                vm.$nextTick(() => {
                    vm.$refs['ppTradepointEdit'].show();
                });
            },

            onAddUser(roles, role){
                roles.push({
                    RoleId: role.RoleId,
                    RoleName: role.RoleName,
                    UserId: null,
                    UserFio: null,
                    ControlUniqueId: Math.random().toString(36).substr(2, 9)
                });
            },

            onRemoveUser(roles, index, rolesIndex){
                if(roles.length === 1){
                    roles.splice(index, 1, {
                        RoleId: roles[0].Id,
                        RoleName: roles[0].Name,
                        ControlUniqueId: Math.random().toString(36).substr(2, 9)
                    });
                }
                else{
                    roles.splice(index, 1);
                    this.$set(this.selectedTradepoint, roles, rolesIndex);
                }
            },

            onDisableUser(roles, index, rolesIndex) {
              roles[index].Disabled = roles[index].Disabled !== true;
              /*this.$set(roles, roles[index], index);
              this.$set(this.tradepointRolesGrouped, roles, rolesIndex);*/
            },

            onFileChange(){
                let vm = this;

                let files = document.getElementById('dropFiles').files;
                if (files.length > 0) {
                    if (window.FormData !== undefined) {
                        let data = new FormData();
                        for (let x = 0; x < files.length; x++) {
                            data.append("file" + x, files[x]);
                        }
                        let tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
                        vm.importResult = null;
                        let projectId = this.$route.params.projectId;
                        let headers = {};
                        if(tokenInfo != null){
                            headers.Authorization = 'bearer ' + tokenInfo.access_token;
                        }

                        UI.blockUI('#app');
                        $.ajax({
                            type: "POST",
                            url: config.apiUrl + '/api/tradepoints/import?projectId=' + projectId,
                            contentType: false,
                            processData: false,
                            headers: headers,
                            data: data,
                            success: function (resp) {
                                if (resp.hasError) {
                                    UI.toastr.error('Ошибка импорта');
                                }
                                else {
                                    console.info('resp', resp)
                                    vm.importResult = resp.result.data;
                                    UI.toastr.success('Успешно импортировано');
                                    vm.page = 1;
                                    vm.tradePoints = [];
                                    vm.loadNext();
                                }
                                UI.unblockUI('#app');
                            },
                            error: function (xhr, status, p3) {
                                UI.toastr.error(xhr.responseText);
                                UI.unblockUI('#app');
                            }
                        });
                    } else {
                        UI.toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                    }
                }
            },

            tradePointUserChange(user, role){
                if(user != null) {
                    role.UserFio = user.Name;
                    role.UserId = user.Id;
                }
                else{
                    this.unselectRoleUser(role);
                }
            },

            searchUserFunction(searchText, callback, extra) {
                let vm = this;

                vm.callApiWrapper(backendApi.userSearch(0, 50, vm.$route.params.projectId, extra, searchText))
                    .then(function (resp) {
                        // уже назначенные на роли пользователи
                        let users = [];
                        for(let roleGroup of vm.tradepointRolesGrouped){
                            users = _.concat(users, _.map(roleGroup, function(role){
                                return role.UserId;
                            }));
                        }

                        // убираем таких пользователей из выдачи
                        let filteredData = _.filter(resp.data, function (item) {
                            return !_.includes(users, item.Id);
                        });

                        // console.info('users:', JSON.stringify(users));
                        // console.info('resp.data', JSON.stringify(resp.data));
                        // console.info('filteredData:', JSON.stringify(filteredData));
                        callback(filteredData);
                    })
            },

            unselectRoleUser(role){
                role.UserId = null;
                role.UserFio = null;
            },

            getFilterValue(role){
                if(!role.UserId){
                    return null;
                }else {
                    return {
                        Id: role.UserId,
                        Name: role.UserFio
                    };
                }
            },

            onChangeDate(item, formatted, raw) {
                item[raw] = moment(item[formatted], 'DD.MM.YYYY').format();
            },

            onAddItem() {
                let vm = this;

                let editedItem = _.find(vm.tradePoints, { Edited: true });
                if (editedItem) {
                    return;
                }

                let roles = [];
                for(let r = 0; r < vm.roles.length; r++) {
                    if (!vm.roles[r].Claims.find(x => x.ClaimId === vm.claimEnums.ttAccess)) {
                        roles.push({
                            RoleId: vm.roles[r].Id,
                            RoleName: vm.roles[r].Name
                        });
                    }
                }

                vm.tradePoints.splice(0, 0, {
                    Id: 0,
                    Edited: true,
                    Roles: roles
                });
            },

            onRemoveItem(item, index) {
                let vm = this;
                if (item.Id > 0) {
                    backendApi.tradePointDelete(item.Id).then(function (response) {
                        //console.info('onRemoveItem -> response', response)
                        UI.unblockUI('.portlet');
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при удалении торговой точки');
                        } else {
                            vm.tradePoints.splice(index, 1);
                        }
                    });
                }
                else {
                    vm.tradePoints.splice(index, 1);
                }
            },

            loadNext() {
                let vm = this;

                let projectId = this.$route.params.projectId;

                vm.loading = true;
                UI.blockUI('.dataContent', 'Загрузка...');
                return this.callApiWrapper(backendApi.tradePointList((this.page - 1) * rowsPerPage, rowsPerPage, projectId, vm.filter))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки торговых точек');
                        }
                        else {
                            if (resp.data && resp.data.length) {
                                for (let item of resp.data) {
                                    item.Edited = false;

                                    if(item.Roles == null){
                                        item.Roles = [];
                                    }

                                    for(let r = 0; r < vm.roles.length; r++){

                                        //if(!vm.roles[r].Claims.find(x => x.ClaimId === vm.claimEnums.ttAccess)) {

                                        // не исключаем из показа роли с полным доступом к тт
                                        let ttAccess = vm.roles[r].Claims.find(x => x.ClaimId === vm.claimEnums.ttAccess) ? true: false
                                            let pointRoles = item.Roles.filter((i) => i.RoleId === vm.roles[r].Id);
                                            if (!pointRoles.length && !ttAccess) {
                                                item.Roles.splice(r, 0, {
                                                    RoleId: vm.roles[r].Id,
                                                    RoleName: vm.roles[r].Name,
                                                    ControlUniqueId: 0,
                                                    TtAccess:ttAccess
                                                });
                                            } else if(pointRoles.length) {
                                                _.each(pointRoles, (pointRole, index) => {
                                                    pointRole.RoleName = vm.roles[r].Name;
                                                    pointRole.ControlUniqueId = index;
                                                    pointRole.TtAccess = ttAccess;
                                                });
                                            }
                                        //}

                                    }
                                }

                                vm.tradePoints.push(...resp.data);
                            }
                            else {
                                vm.canBeLoaded = false;
                            }
                        }
                        UI.unblockUI('.dataContent');
                        vm.loading = false;
                    })
            },

            loadRoles() {
                let vm = this;
                return this.callApiWrapper(backendApi.rolesList(vm.$route.params.projectId))
                    .then(function (resp) {
                        if (resp.data) {

                            vm.roles = resp.data.Roles;

                            for(let r = 0; r < vm.roles.length; r++) {
                                if (!vm.roles[r].Claims.find(x => x.ClaimId === vm.claimEnums.ttAccess)) {

                                    vm.tradePointsFilters.push({
                                        Value: 'TradePointRole_' + vm.roles[r].Id,
                                        Name: vm.roles[r].Name
                                    });
                                }
                            }
                        }
                    });
            },

            loadBonusSettings(){
                let vm = this;
                return this.callApiWrapper(backendApi.projectLoad(vm.$route.params.projectId))
                    .then(function (resp) {
                        if (resp.data) {
                            let rsData = JSON.parse(resp.data.ReportSettings || '[]');
                            for(let item of rsData){
                                if(typeof item.deleted === 'undefined'){
                                    item.deleted = false;
                                }
                            }

                            vm.ReportSettings = rsData;

                            vm.bonusSettings = JSON.parse(resp.data.BonusSettings|| '[]');
                        }
                    });
            },

            loadUsers() {
                let vm = this;
                return vm.callApiWrapper(backendApi.usersList(0, 100, vm.$route.params.projectId))
                    .then(function (resp) {
                        if (resp.data && resp.data.length) {
                            vm.users = resp.data;
                        }
                    });
            },

            saveItem(item) {
                let vm = this;

                return vm.$validator.validate().then(result => {
                    if (!result) {
                        return false;
                    } else {
                        UI.blockUI('.portlet', 'Сохранение...');

                        let projectId = vm.$route.params.projectId;

                        let saveObj = Object.assign({}, item, {
                            ProjectId: projectId
                        });

                        let roles = [];
                        for(let roleGroup of vm.tradepointRolesGrouped){
                            roles = _.concat(roles, _.map(roleGroup, function(role){
                                return {
                                    RoleId: role.RoleId,
                                    UserId: role.UserId,
                                    UserFio: role.UserFio,
                                    RoleName: role.RoleName,
                                    Disabled: role.Disabled
                                };
                            }));
                        }
                        saveObj.Roles = roles;
                        if (saveObj.Latitude != null && (saveObj.Latitude + '').length > 0) {
                            saveObj.Latitude = (saveObj.Latitude + '').replace(',', '.');
                            if (saveObj.Longitude == null || (saveObj.Longitude + '').length === 0) {
                                UI.toastr.error('Долгота обязательна при заполненной Широте');
                                return;
                            }
                        }
                        if (saveObj.Longitude != null && (saveObj.Longitude + '').length > 0) {
                            saveObj.Longitude = (saveObj.Longitude + '').replace(',', '.');
                            if (saveObj.Latitude == null || (saveObj.Latitude + '').length === 0) {
                                UI.toastr.error('Широта обязательна при заполненной Долготе');
                                return;
                            }
                        }

                        console.info('saveObj:', JSON.stringify(saveObj));

                        backendApi.tradePointSave(saveObj).then(function (response) {
                            UI.unblockUI('.portlet');
                            if (response.hasError) {
                                UI.toastr.error('Ошибка при сохранении торговой точки');
                            } else {
                                // todo: перезагружать конкретную запись

                                if (item.Id === 0) {
                                    item.Id = response.data;
                                }
                                item.Roles = roles;
                                item.Edited = false;
                                vm.closeModal('ppTradepointEdit');
                            }
                        });
                    }
                });
            },

            onCancel(){
                this.closeModal('ppTradepointEdit');
                this.selectedTradepoint = Object.assign({}, this.originData);
                this.$set(this.tradePoints, this.selectedTradepointIndex, this.selectedTradepoint);
            },

            onItemClick(item, index) {
                let vm = this;
                vm.tradepointEditShow(item, index);
            },

            onFilterChange(filter) {
                this.filter = filter;
                this.tradePoints = [];
                this.loading = false;
                this.canBeLoaded = true;
                this.page = 1;
                this.loadNext();
            },

            searchFunction(tableName, columnName, search, filters, searchPage, callback) {
                let filterFormatted = '';
                if(filters){
                    filterFormatted = filters.map(x => {return JSON.stringify(x)});
                }
                this.callApiWrapper(backendApi.tradePointDistinctValues(columnName, this.$route.params.projectId, search, filterFormatted, (searchPage - 1) * 30, 30))
                    .then(function (resp) {
                        callback(resp.data);
                    })
            },

            onExport() {
                let vm = this;
                let projectId = vm.$route.params.projectId;

                let filterstr = [];
                if (this.filter) {
                    for (let i = 0; i < this.filter.length; i++) {
                        let item = this.filter[i];
                        filterstr.push(JSON.stringify(item));
                    }
                }

                UI.blockUI('#app');
                vm.callApiWrapper(backendApi.tradePointExport(projectId, filterstr))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время экспорта');
                        }
                        else {
                            let exportFile = resp.data;
                            if (exportFile != null) {
                                UI.downloadFileByBytes(exportFile, 'Торговые точки.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                            }
                        }
                        UI.unblockUI('#app');
                    });
            },

            getFilterForUri(){
                let str = '';
                if(this.filter) {
                    for (let i = 0; i < this.filter.length; i++) {
                        let item = this.filter[i];
                        str += `&filter[${i}]=${encodeURIComponent(JSON.stringify(item))}`;
                    }
                }
                return str;
            },
        },

        mounted() {
            let vm = this;

            Promise.all([this.loadRoles(), this.loadBonusSettings()]).then(function () {
                vm.loadNext();
            });
            this.loadUsers();

            vm.$nextTick(() => {

                $('.body-panel-content').on('scroll', function () {
                    if (!vm.loading && vm.canBeLoaded) {
                        let elem = $(this);
                        if (elem[0].scrollHeight - elem.scrollTop() - 200 <= elem.outerHeight()) {
                            vm.page++;
                            vm.loadNext();
                        }
                    }
                });

            })
        },

        destroyed() {
            $('.body-panel-content').off('scroll');
        }
    }
</script>

<style scoped>
    .table-point-address{
        width: 500px !important;
        min-width: 500px !important;
        margin: 0 30px;
    }
</style>


// WEBPACK FOOTER //
// Content/src/views/TradePoints.vue